export default "__VITE_ASSET__3850bcd9__"